import { render, staticRenderFns } from "./ChooseDropshipper.vue?vue&type=template&id=1c7d9938&"
import script from "./ChooseDropshipper.vue?vue&type=script&lang=js&"
export * from "./ChooseDropshipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports